<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_ed1"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-select v-model="listQuery.isHisTory" @change="funcFilter">
          <el-option label="实时单" value="0" />
          <el-option label="历史单" value="1" />
        </el-select>
        <el-button
          v-if="getLimit('etcLongDistance_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('etcLongDistance_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
        <el-button
          v-if="getLimit('etcLongDistance_multiple_search_button')"
          @click="funcMultipleSearch"
        >
          批量查询发票
        </el-button></template
      >
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      align="center"
      :loading="loading"
      :footer-cell-class-name="footerCellClassName"
      :data="tableData"
      export-config
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <!-- <vxe-table-column min-width="150">
        <template v-slot:header>
          <el-select v-model="listQuery.isHisTory" @change="funcFilter">
            <el-option label="实时单" value="0" />
            <el-option label="历史单" value="1" />
          </el-select>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderSplitNum"
          title="分单号"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderSplitNum"
            placeholder="请输入分单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderDetailCode"
          title="运单号"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderDetailCode"
            placeholder="请输入运单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderStatus"
          title="状态"
          :formatter="
            ({ cellValue }) => formatterOptions(cellValue, 'orderStatus')
          "
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.orderStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in orderStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="ETC状态"
          :formatter="({ cellValue }) => formatterOptions(cellValue, 'status')"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" clearable placeholder="请选择">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="etcStatus"
        title="开票状态"
        :formatter="formatterEtcStatus"
        min-width="150"
        sortable
      />
      <vxe-table-column
        field="etcFee"
        title="ETC费用"
        min-width="200"
        sortable
      />
      <vxe-table-column>
        <vxe-table-column
          field="licenseNumber"
          title="车牌号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.licenseNumber"
            placeholder="请输入车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="startTime"
          title="开始时间"
          min-width="400"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.startTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'startTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="endTime"
          title="结束时间"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.endTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'endTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" min-width="150">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('etcLongDistance_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="orderDesil(scope.row.orderCode)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('etcLongDistance_ticket_button') && scope.row.status < 2
            "
            class="item"
            effect="dark"
            content="开票"
            placement="top"
          >
            <vxe-button type="text" @click="orderDeterReport(scope.row.code)">
              <i class="el-icon-s-ticket" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('etcLongDistance_lockticket_button') &&
                scope.row.status >= 2
            "
            class="item"
            effect="dark"
            content="查看开票"
            placement="top"
          >
            <vxe-button type="text" @click="orderDeterDeail(scope.row.code)">
              <i class="el-icon-tickets" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="tuteship"
      title="运输单详情"
      width="1000"
      height="80%"
      resize
    >
      <ordergoods ref="detailRef" />
    </vxe-modal>
    <vxe-modal
      v-model="modelInvoice"
      title="ETC发票详情"
      fullscreen
      remember
      width="1000"
      height="80%"
      resize
    >
      <orderDetailEtcInvoice ref="etcInvoiceRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>

<script>
import {
  selectOrderSplitList,
  historySplitOrderEtcReport,
  splitOrderEtcReport,
  getOrderDetailInvoiceBatch
} from "@/api/etc";
import ordergoods from "@/components/WaybillDetails";
import orderDetailEtcInvoice from "./orderDetailEtcInvoice";

export default {
  name: "EtcLongDistance",
  components: {
    ordergoods,
    orderDetailEtcInvoice
  },
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      tuteship: false,
      modelInvoice: false,
      modelDistance: false,
      copy: false,
      exportObj: {
        exportUrl: "/ntocc-tms-api/etc/exportLongDistance", //导出接口
        name: "长途分单"
      },
      listQuery: {
        startTimeRange: "",
        endTimeRange: "",
        isHisTory: "0",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        etcStatus: ""
      },
      orderStatusOptions: [
        { value: 1, label: "已接单" },
        { value: 2, label: "已装货" },
        { value: 3, label: "已卸货" },
        { value: 4, label: "已结算" },
        { value: 5, label: "已打款" }
      ],
      // 状态 0，未开始、1一开始 ，2已结束，3开票 4过期（异常）
      statusOptions: [
        { value: 0, label: "未开始" },
        { value: 1, label: "已开始" },
        { value: 2, label: "已结束" },
        { value: 3, label: "已开票" },
        { value: 4, label: "已过期" },
        { value: 6, label: "无发票" }
      ],

      // 开票状态
      etcStatusOptions: [
        { value: 3, label: "开票完成" },
        { value: 2, label: "开票中" }
      ],
      //机构信息
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        selectOrderSplitList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 批量查询发票
    funcMultipleSearch() {
      const selectRecords = this.$refs.xTable.getCheckboxRecords();
      if (!selectRecords || selectRecords.length === 0) {
        this.$message({ message: "请选择需要查询的发票", type: "warning" });
      } else if (selectRecords.length > 100) {
        this.$message({ message: "批量处理最多100条数据", type: "warning" });
      } else {
        const rLoading = this.openLoading();
        const orderCodes = selectRecords
          .map(item => item.orderSplitNum)
          .join(",");
        getOrderDetailInvoiceBatch({ orderCodes }).then(response => {
          rLoading.close();
          let type = response.status === 0 ? "success" : "error";
          this.$message({
            message: response.msg,
            type: type
          });
          this.findList();
        });
      }
    },
    // 底部颜色设置
    footerCellClassName({ $rowIndex, column, columnIndex }) {
      if (columnIndex === 0) {
        if ($rowIndex === 0) {
          return "col-blue";
        } else {
          return "col-red";
        }
      }
    },
    // 翻译
    formatterOptions(cellValue, prefix) {
      const item = this[`${prefix}Options`].find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    },
    // 翻译开票状态
    formatterEtcStatus({ cellValue }) {
      const item = this.etcStatusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    //ETC 开票
    orderDeterReport(code) {
      this.$confirm("确认要开票？")
        .then(_ => {
          this.Billing(code);
        })
        .catch(_ => {});
    },
    async Billing(code) {
      const rLoading = this.openLoading();
      let isHisTory = this.listQuery.isHisTory;
      let res =
        isHisTory == 1
          ? await historySplitOrderEtcReport({ code })
          : await splitOrderEtcReport({ code });
      rLoading.close();
      this.$message.success(res.msg);
      this.findList();
    },
    //ETC详情
    orderDeterDeail(code) {
      this.$refs.etcInvoiceRef.findInfo(code, true);
      this.modelInvoice = true;
    },
    orderDesil(c) {
      this.$refs.detailRef.Getdetails(c);
      this.tuteship = true;
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>

<style scoped></style>
